package dtos.sponsor

import core.enums.ESponsorPreviewTypeDB
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 17.03.20
 * Author : mariorosshirt
 */

@Serializable
data class SponsorDTOOut(

    @SerialName("id")
        val mId: Int,

    @SerialName("imageUrl1")
        val mImageUrl1: String?,

    @SerialName("image1Width")
        val mImage1Width: Int,

    @SerialName("image1Height")
        val mImage1Height: Int,

    @SerialName("imageUrl2")
        val mImageUrl2: String?,

    @SerialName("image2Width")
        val mImage2Width: Int,

    @SerialName("image2Height")
        val mImage2Height: Int,

    @SerialName("linkUrl")
        val mLinkUrl: String,

    @SerialName("text1")
        val mText1: String?,

    @SerialName("text2")
        val mText2: String?,

    @SerialName("text3")
        val mText3: String?,

    @SerialName("text4")
        val mText4: String?,

    @SerialName("screen")
        val mScreen: String,

    @SerialName("interval")
        val mInterval: Int?,

    @SerialName("sponsorPreviewType")
        val mSponsorPreviewType: ESponsorPreviewTypeDB,

    @SerialName("indicatorColor")
        val mIndicatorColor: String?,

    @SerialName("leftIconBackgroundColor")
        val mLeftIconBackgroundColor: String?,

    @SerialName("leftIconTintColor")
        val mLeftIconTintColor: String?,

    @SerialName("leftIconTintEnabled")
        val mLeftIconTintEnabled: Boolean?,

    @SerialName("middleTextTintColor")
        val mMiddleTextTintColor: String?,

    @SerialName("rightTopTintColor")
        val mRightTopTintColor: String?,

    @SerialName("rightBottomTintColor")
        val mRightBottomTintColor: String?
) {

    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}